import { ArrayUtils } from '@colonist/utils';
export const CLOSE_ALL_DIALOGS_EVENT = 'colonist:closeAllDialogs';
export function createDialogManager(keyEventTarget) {
    const dialogs = [];
    const onKeyDown = (event)=>{
        if (event.key != 'Escape') return;
        if (event.defaultPrevented) return;
        const top = ArrayUtils.last(dialogs);
        top === null || top === void 0 ? void 0 : top.close();
    };
    const onCloseAllDialogs = ()=>{
        const closing = dialogs.slice();
        dialogs.length = 0;
        closing.forEach((dialog)=>dialog.close());
    };
    keyEventTarget.addEventListener('keydown', onKeyDown);
    keyEventTarget.addEventListener(CLOSE_ALL_DIALOGS_EVENT, onCloseAllDialogs);
    return {
        register: (dialog)=>{
            dialogs.push(dialog);
            return ()=>{
                ArrayUtils.removeElementFromArray(dialogs, dialog);
            };
        },
        destroy: ()=>{
            keyEventTarget.removeEventListener('keydown', onKeyDown);
            keyEventTarget.removeEventListener(CLOSE_ALL_DIALOGS_EVENT, onCloseAllDialogs);
        }
    };
}
